// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"52f72cb8","393":"fb64887b","573":"5c3a0121","666":"64a31f80","900":"4253ec74"}[chunkId] + ".chunk.css";
};